import { Option } from './option';
import { SelectedOption } from './selected-option';
import { ModelCategoryMessage } from './model-category-messages';

export class QuoteSummary {
    public QuoteId: number;

    // Facility and Retailer Info
    public RetailerName: string;
    public RetailerAddress: string;
    public RetailerPhone: string;
    public FacilityName: string;
    public FacilityAddress: string;
    public FacilityPhone: string;
    public FacilityFax: string;
    public RetailerNumber: string;

    // Quote and Order Summary
    public CustomerName: string;
    public DateCreated: Date;
    public LastModifiedDate: Date;
    public ProductLineName: string;
    public ModelName: string;
    public Bedrooms: number;
    public Bathrooms: number;
    public SquareFootage: number;
    public SalesRep: string;
    public ModelDescription: string;
    public PlantNumber: number;
    public ProductLineCode: string;
    public ModelNumber: string;
    public OrderedBy: string;
    public QuoteStatusesID: number;
    public SalesEmail: string;

    // Options and Categories Summary
    public Options: SelectedOption[];
    public Categories: CategoryNameId[]; //Needed for page refresh
    public CategoryNames: string[]; //Needed for page refresh
    public ModelCategoryMessages: ModelCategoryMessage[];
    public HomeOptionsCategories: CategoryNameId[];

    // Subtotal and Grand Total Info
    public NoPricing: boolean;
    public BaseCost: number;
    public OptionsTotal: number;
    public Surcharge: number;
    public Transportation: number;
    public Taxes: number;
    public Dues: number;
    public DuesOnly: number;
    public VIPAmount: number;
    public PartnerAssistanceAmount: number;
    public PartnerAssistancePercentage: number;
    public VIPPercentage: number;
    public DiscountPercent: number;
    public GrandTotal: number;
    public ModelBaseOverride: number;
    public ModelBaseCost: number;
    
    // Logo
    public FacilityLogo: string;

    constructor() {
        //this.Options = new Array<Option>();
        this.Options = new Array<SelectedOption>();
        this.CategoryNames = new Array<string>();
        this.ModelNumber = '';
        this.ProductLineCode = '';
        this.HomeOptionsCategories = new Array<CategoryNameId>();
        this.BaseCost = 0;;
        this.OptionsTotal = 0;;
        this.Surcharge = 0;;
        this.Transportation = 0;;
        this.Taxes = 0;;
        this.Dues = 0;;
        this.DuesOnly = 0;;
        this.VIPAmount = 0;;
        this.PartnerAssistanceAmount = 0;
        this.VIPPercentage = 0;
        this.PartnerAssistancePercentage = 0;
        this.DiscountPercent = 0;;
        this.GrandTotal = 0;;
        this.ModelBaseOverride = 0;;
        this.ModelBaseCost = 0;
    }
}

export class CategoryNameId {
    public CategoryName: string;
    public CategoryId: number;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/model/quote-summary.ts